<script>
import Modal from "@/components/_Shared/Modal";
import Feedback from "./Feedback";
import FullFeedback from "./FullFeedback";
import Professional from "./Professional";

import { mapActions } from "vuex";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  props: {
    professional: {
      type: Object,
      required: true
    }
  },
  components: {
    Professional,
    Feedback,
    FullFeedback,
    Modal,
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        autoHeight: true,
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      page: 0,
      feedbacks: [],
      loader: false,
      fullFeedback: null
    };
  },
  methods: {
    ...mapActions("professionals", ["getFeedbacks"]),

    async increment() {
      this.loader = true;
      this.page++;

      try {
        let data = {
          professionalID: this.professional.id,
          page: this.page
        };
        let feedbacks = await this.getFeedbacks(data);
        this.feedbacks = [...this.feedbacks, ...feedbacks];
      } catch (e) {
        this.$toasted.error(e);
      }

      this.loader = false;
    }
  },
  mounted() {
    this.increment();
  }
};
</script>

<template>
  <modal v-if="professional" size="md" @close="$emit('close')">
    <professional :professional="professional" slot="header" />

    <template slot="body">
      <h3>Avaliações</h3>

      <swiper v-if="feedbacks.length" :options="swiperOption" @reachEnd="increment()">
        <swiper-slide v-for="feedback in feedbacks" :key="feedback.id">
          <feedback :feedback="feedback" @click="fullFeedback = feedback" />
        </swiper-slide>
        <div class="swiper-button-prev" slot="button-prev">&#8249;</div>
        <div class="swiper-button-next" slot="button-next">&#8250;</div>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>

      <div
        class="no-feedbacks"
        v-else-if="!loader"
      >Ops! Esse profissional ainda não recebeu um depoimento dos seus clientes :/</div>

      <div v-else class="auto-fill"></div>

      <transition v-if="loader" name="fade" mode="in-out">
        <div class="loading">
          <img src="/static/loader-purple.svg" height="50px" class="mb-5" />
          buscando avaliações
        </div>
      </transition>
      <full-feedback v-if="fullFeedback" :feedback="fullFeedback" @close="fullFeedback = null" />
    </template>

    <template slot="footer">
      <button class="btn bg-purple-outline" @click="$emit('close')">fechar</button>
    </template>
  </modal>
</template>

<style scoped>
.auto-fill {
  height: 140px;
}
.loading {
  user-select: none;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 140px;
  margin-top: -140px;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 200;
  font-size: 12px;
  font-style: italic;
}

h3 {
  text-align: center;
  color: var(--purple);
  margin: 5px 0;
  font-size: 14px;
  text-transform: uppercase;
}

.no-feedbacks {
  text-align: center;
  font-style: italic;
  font-size: 14px;
}

.swiper-button-next,
.swiper-button-prev {
  display: none;
}

@media (min-width: 920px) {
  .swiper-button-next,
  .swiper-button-prev {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Professionals/Feedbacks/Index.vue